module.exports = __webpack_public_path__ + "static/media/lake.43841c54.png";